// extracted by mini-css-extract-plugin
export default {"container":"dSD2q8N9I2","message":"CHHHlWrurf","error":"BQxHiOfF0f","icon":"YBkFF1stjN","value":"_7sBl8BQY5I"};